"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSCalendar = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = tslib_1.__importStar(require("react"));
/** @jsxRuntime classic */
/** @jsx jsx */
var react_2 = require("@emotion/react");
var moment_1 = tslib_1.__importDefault(require("moment"));
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var react_virtualized_1 = require("react-virtualized");
var Theme_1 = require("../../../../Theme");
var BDSBackdrop_1 = require("../../../common/BDSBackdrop/BDSBackdrop");
var BDSCalendar_style_1 = require("./BDSCalendar.style");
var BDSFontIcon_1 = require("../../Basic/BDSFontIcon/BDSFontIcon");
var BDSBorderSection_1 = require("../BDSBorderSection/BDSBorderSection");
// viewMonth 월(月)에 해당하는 JSX 를 반환
function monthRender(viewMonth, dateRange, disableFuture, eventHandle, highlightRange, selectableRange) {
    var startOfMonth = moment_1.default(viewMonth).startOf('month'); // viewMonth 의 첫째 날
    var endOfMonth = moment_1.default(viewMonth).endOf('month'); // viewMonth 의 마지막 날
    var startOfLastWeek = moment_1.default(endOfMonth).startOf('week'); // viewMonth 의 마지막 주 일요일
    var result = [];
    var cursor = moment_1.default(startOfMonth).startOf('week'); // 지난 달의 마지막 일요일이거나 이번 달의 첫번째 일요일
    var today = moment_1.default().startOf('day');
    var _loop_1 = function () {
        var week = [];
        // bg-inner-date << 안에 active 넣어야 함
        lodash_1.default.times(7, function (i) {
            // cursor 은 viewMonth의 지난 달의 마지막 일요일 또는
            // viewMonth 의 첫번째 일요일이 될 수 있다.
            var currentDate = moment_1.default(cursor).add(i, 'day');
            var isStartBg = '';
            var isEndBg = '';
            var isIgnoreDate = '';
            var isToday = '';
            var isDisabled = '';
            var isActiveDate = '';
            var isActiveBg = '';
            var isHighlightStartBg = '';
            var isHighlightEndBg = '';
            var isHighlightActiveDate = '';
            var isHighlightActiveBg = '';
            if (currentDate.isSame(today, 'day'))
                isToday = ' today';
            if (disableFuture && currentDate.isAfter(today))
                isDisabled = ' disabled';
            if (selectableRange && (currentDate.isAfter(selectableRange.end) || currentDate.isBefore(selectableRange.start)))
                isDisabled = ' disabled';
            if (dateRange) {
                isActiveDate =
                    currentDate.isSame(dateRange.start, 'day') || currentDate.isSame(dateRange.end, 'day') ? ' active' : '';
                isActiveBg = currentDate.isBetween(dateRange.start, dateRange.end, 'day') ? ' active' : '';
                if (!moment_1.default(dateRange.start).isSame(dateRange.end, 'day')) {
                    isStartBg = currentDate.isSame(dateRange.start, 'day') ? ' active' : '';
                    isEndBg = currentDate.isSame(dateRange.end, 'day') ? ' active' : '';
                }
                if (currentDate.isBefore(startOfMonth))
                    if (startOfMonth.isBetween(dateRange.start, dateRange.end, 'day', '(]') &&
                        !moment_1.default(dateRange.start).isSame(dateRange.end, 'day'))
                        isActiveBg = ' active';
                    else
                        isActiveBg = '';
                if (currentDate.isAfter(endOfMonth))
                    if (endOfMonth.isBetween(dateRange.start, dateRange.end, 'day', '[)') &&
                        !moment_1.default(dateRange.start).isSame(dateRange.end, 'day'))
                        isActiveBg = ' active';
                    else
                        isActiveBg = '';
                if (highlightRange) {
                    isHighlightActiveDate =
                        currentDate.isSame(highlightRange.start, 'day') || currentDate.isSame(highlightRange.end, 'day')
                            ? ' highlight'
                            : '';
                    isHighlightActiveBg = currentDate.isBetween(highlightRange.start, highlightRange.end) ? ' highlight' : '';
                    if (!moment_1.default(highlightRange.start).isSame(highlightRange.end, 'day') &&
                        !currentDate.isBetween(dateRange.start, dateRange.end, 'day', '[]')) {
                        isHighlightStartBg = currentDate.isSame(highlightRange.start, 'day') ? ' highlight' : '';
                        isHighlightEndBg = currentDate.isSame(highlightRange.end, 'day') ? ' highlight' : '';
                    }
                    if (currentDate.isBefore(startOfMonth))
                        if (startOfMonth.isBetween(highlightRange.start, highlightRange.end, 'day', '(]') &&
                            !moment_1.default(highlightRange.start).isSame(highlightRange.end, 'day'))
                            isHighlightActiveBg = ' highlight';
                        else
                            isHighlightActiveBg = '';
                    if (currentDate.isAfter(endOfMonth))
                        if (endOfMonth.isBetween(highlightRange.start, highlightRange.end, 'day', '[)') &&
                            !moment_1.default(highlightRange.start).isSame(highlightRange.end, 'day'))
                            isHighlightActiveBg = ' highlight';
                        else
                            isHighlightActiveBg = '';
                }
            }
            if (currentDate.isBefore(startOfMonth)) {
                isIgnoreDate = ' hide';
                isStartBg = '';
                isEndBg = '';
                isHighlightStartBg = '';
                isHighlightEndBg = '';
            }
            if (currentDate.isAfter(endOfMonth)) {
                isIgnoreDate = ' hide';
                isStartBg = '';
                isEndBg = '';
                isHighlightStartBg = '';
                isHighlightEndBg = '';
            }
            week.push(jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "bg-date" + isHighlightActiveBg + isActiveBg }, { children: [jsx_runtime_1.jsx("div", { className: "bg-inner-start " + isStartBg + isHighlightStartBg }, void 0),
                    jsx_runtime_1.jsx("div", { className: "bg-inner-end " + isEndBg + isHighlightEndBg }, void 0),
                    jsx_runtime_1.jsx("div", tslib_1.__assign({ role: "button", tabIndex: 0, className: "bg-inner-date " + isHighlightActiveDate + isActiveDate + isIgnoreDate + isToday + isDisabled, onClick: function () {
                            return (!disableFuture || !currentDate.isAfter(today)) &&
                                !currentDate.isBefore(startOfMonth) &&
                                !currentDate.isAfter(endOfMonth) &&
                                (selectableRange
                                    ? currentDate.isBetween(selectableRange.start, selectableRange.end, 'day', '[]')
                                    : true) &&
                                eventHandle &&
                                eventHandle({
                                    eventType: 'click',
                                    date: currentDate,
                                });
                        }, onMouseEnter: function () {
                            return (!disableFuture || !currentDate.isAfter(today)) &&
                                !currentDate.isBefore(startOfMonth) &&
                                !currentDate.isAfter(endOfMonth) &&
                                (selectableRange
                                    ? currentDate.isBetween(selectableRange.start, selectableRange.end, 'day', '()')
                                    : true) &&
                                eventHandle &&
                                eventHandle({
                                    eventType: 'hover',
                                    date: currentDate,
                                });
                        } }, { children: jsx_runtime_1.jsx("span", { children: currentDate.date() }, void 0) }), void 0)] }), currentDate.format('L')));
        });
        result.push(jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-week" }, { children: week }), cursor.format('L')));
        cursor.add(1, 'week');
    };
    while (startOfLastWeek.isSameOrAfter(cursor)) {
        _loop_1();
    }
    return (jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "bg-calendar-display-month-detail" }, { children: [jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-display-month" }, { children: viewMonth ? viewMonth.format('YYYY.MM') : '' }), void 0),
            jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-display-date" }, { children: result }), void 0)] }), void 0));
}
var usePrevious = function (value) {
    var ref = react_1.useRef();
    react_1.useEffect(function () {
        ref.current = value;
    });
    return ref.current;
};
/**
 * @constructor
 */
var BDSCalendar = function (props) {
    var theme = Theme_1.lightTheme;
    var themeCss = react_2.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    background-color: ", ";\n\n    &.active {\n      color: ", ";\n      background-color: ", ";\n    }\n\n    .bg-calendar-current-date {\n      color: ", ";\n    }\n\n    .bg-inner-date {\n      &.active {\n        color: white;\n        background-color: ", ";\n        box-shadow: 0px 4px 16px rgba(0, 111, 255, 0.4);\n        border-radius: 8px;\n      }\n    }\n\n    .bg-calendar-select-apply {\n      background-color: ", ";\n    }\n  "], ["\n    background-color: ", ";\n\n    &.active {\n      color: ", ";\n      background-color: ", ";\n    }\n\n    .bg-calendar-current-date {\n      color: ", ";\n    }\n\n    .bg-inner-date {\n      &.active {\n        color: white;\n        background-color: ", ";\n        box-shadow: 0px 4px 16px rgba(0, 111, 255, 0.4);\n        border-radius: 8px;\n      }\n    }\n\n    .bg-calendar-select-apply {\n      background-color: ", ";\n    }\n  "])), theme.colors.bg2, theme.colors.color3, theme.colors.bg2, theme.colors.highlight, theme.colors.primary, theme.colors.primary);
    var listRef = react_1.useRef(null); // virtual-list 컴포넌트를 제어하기 위한 Ref
    var _a = react_1.useState(false), isOver = _a[0], setIsOver = _a[1]; // Calendar 버튼의 hover effect를 위한 State
    var propsObj = props;
    // 화면에 노출되는 Month의 범위, 기본값은 12 Month
    var viewRange = propsObj.viewRange
        ? propsObj.viewRange
        : {
            start: moment_1.default().subtract(14, 'months').startOf('month'),
            end: propsObj.disableFuture ? moment_1.default().startOf('day') : moment_1.default().add(12, 'months').startOf('day'),
        };
    // 화면에 노출되는 Month의 Count, 기본값은 12
    var monthCount = Math.abs(viewRange === null || viewRange === void 0 ? void 0 : viewRange.start.diff(viewRange.end, 'month'));
    // 적용되는 실제 DateRange
    var _b = react_1.useState(propsObj.initSelectedDateRange || propsObj.initDateRange), selectedDateRange = _b[0], setSelectedDateRange = _b[1];
    // 날짜를 click, hover 하여 선택되는 임시 DateRange
    var _c = react_1.useState(propsObj.initDateRange
        ? propsObj.initDateRange
        : {
            start: moment_1.default().startOf('day'),
            end: moment_1.default().startOf('day'),
        }), dateRange = _c[0], setDateRange = _c[1];
    react_1.useEffect(function () {
        setSelectedDateRange(props.initSelectedDateRange || props.initDateRange);
        if (props.initDateRange)
            setDateRange(props.initDateRange);
    }, [props.initSelectedDateRange, props.initDateRange]);
    // Left-Control Panel의 기본 선택값
    var _d = react_1.useState(propsObj.language === 'ko' ? '직접 설정 기간' : 'Manually set period'), selectLabel = _d[0], setSelectLabel = _d[1];
    var init = [];
    var _e = react_1.useState(init), items = _e[0], setItems = _e[1];
    // Calendar 는 Button 상태와 Calendar 상태로 나뉜다.
    var _f = react_1.useState(false), showCalendar = _f[0], setShowCalendar = _f[1];
    // DateRange는 범위 값이므로 start, end 에 해당하는 최대 2개의 Moment를 저장하는 State
    var _g = react_1.useState([]), dateSelection = _g[0], setDateSelection = _g[1];
    var dateEventHandle = react_1.useCallback(function (event) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (event.eventType) {
                case 'click':
                    setSelectLabel(propsObj.language === 'ko' ? '직접 설정 기간' : 'Manually set period');
                    if (props.isSingleDateRange) {
                        setDateSelection([]);
                        setDateRange({
                            start: moment_1.default(event.date),
                            end: moment_1.default(event.date),
                        });
                        break;
                    }
                    if (dateSelection.length === 0) {
                        // DateRange.start 선택
                        dateSelection.push(event.date);
                        setDateSelection(dateSelection);
                        setDateRange({
                            start: moment_1.default(event.date),
                            end: moment_1.default(event.date),
                        });
                    }
                    else {
                        // DateRange.end 선택
                        setDateSelection([]);
                        setDateRange({
                            start: dateSelection[0].isBefore(event.date) ? moment_1.default(dateSelection[0]) : moment_1.default(event.date),
                            end: dateSelection[0].isAfter(event.date) ? moment_1.default(dateSelection[0]) : moment_1.default(event.date),
                        });
                    }
                    break;
                case 'hover':
                    if (dateSelection.length > 0) {
                        setDateRange({
                            start: dateSelection[0].isBefore(event.date) ? moment_1.default(dateSelection[0]) : moment_1.default(event.date),
                            end: dateSelection[0].isAfter(event.date) ? moment_1.default(dateSelection[0]) : moment_1.default(event.date),
                        });
                    }
                    break;
                default:
            }
            return [2 /*return*/];
        });
    }); }, [dateSelection]);
    var updateViewIndex = react_1.useCallback(function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var viewMonthCount, startMonthCount;
        return tslib_1.__generator(this, function (_a) {
            if (!listRef || !listRef.current)
                return [2 /*return*/];
            viewMonthCount = moment_1.default(viewRange.start).year() * 12 + moment_1.default(viewRange.start).month();
            startMonthCount = moment_1.default(dateRange.start).year() * 12 + moment_1.default(dateRange.start).month();
            listRef.current.scrollToRow(startMonthCount - viewMonthCount - 1);
            return [2 /*return*/];
        });
    }); }, [dateRange.start, viewRange.start]);
    var getMonths = react_1.useCallback(function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var months;
        return tslib_1.__generator(this, function (_a) {
            months = [];
            lodash_1.default.times(monthCount, function (i) {
                months.push(monthRender(moment_1.default(viewRange === null || viewRange === void 0 ? void 0 : viewRange.start).add(i + 1, 'month'), dateRange, props.disableFuture, dateEventHandle, props.highlightRange, props.selectableRange));
            });
            setItems(months);
            return [2 /*return*/];
        });
    }); }, [dateRange, monthCount, viewRange, props.disableFuture, dateEventHandle]);
    var prevShowCalendar = usePrevious(showCalendar);
    react_1.useEffect(function () {
        if (listRef && listRef.current) {
            getMonths().then(function () {
                if (listRef && listRef.current)
                    listRef.current.forceUpdateGrid();
                if (!['직접 설정 기간', 'Manually set period'].includes(selectLabel) || showCalendar !== prevShowCalendar)
                    updateViewIndex().then();
            });
        }
        // TODO: need to fix infinite render problem
    }, [
        dateRange,
        // getMonths,
        listRef,
        showCalendar,
        // updateViewIndex,
        selectLabel,
    ]);
    function selectRange(range) {
        var start = moment_1.default().startOf('day');
        var end = moment_1.default().startOf('day');
        switch (range) {
            case '직접 설정':
            case 'Manual settings':
                setSelectLabel(propsObj.language === 'ko' ? '직접 설정 기간' : 'Manually set period');
                return;
            case '오늘':
            case 'Today':
                start = moment_1.default().startOf('day');
                end = moment_1.default().startOf('day');
                setSelectLabel(propsObj.language === 'ko' ? '오늘' : 'Today');
                break;
            case '어제':
            case 'Yesterday':
                start = moment_1.default().subtract(1, 'day').startOf('day');
                end = moment_1.default().subtract(1, 'day').startOf('day');
                setSelectLabel(propsObj.language === 'ko' ? '어제' : 'Yesterday');
                break;
            case '이번 주':
            case 'This week':
                start = moment_1.default().startOf('week');
                end = moment_1.default().startOf('day');
                setSelectLabel(propsObj.language === 'ko' ? '이번 주' : 'This week');
                break;
            case '지난 주':
            case 'Last week':
                start = moment_1.default().subtract(1, 'week').startOf('week');
                end = moment_1.default().subtract(1, 'week').endOf('week').startOf('day');
                setSelectLabel(propsObj.language === 'ko' ? '지난 주' : 'Last week');
                break;
            case '지난 7일':
            case 'Last 7 days':
                start = moment_1.default().subtract(7, 'day').startOf('day');
                end = moment_1.default().subtract(1, 'day').startOf('day');
                setSelectLabel(propsObj.language === 'ko' ? '지난 7일' : 'Last 7 days');
                break;
            case '지난 14일':
            case 'Last 14 days':
                start = moment_1.default().subtract(14, 'day').startOf('day');
                end = moment_1.default().subtract(1, 'day').startOf('day');
                setSelectLabel(propsObj.language === 'ko' ? '지난 14일' : 'Last 14 days');
                break;
            case '지난 30일':
            case 'Last 30 days':
                start = moment_1.default().subtract(30, 'day').startOf('day');
                end = moment_1.default().subtract(1, 'day').startOf('day');
                setSelectLabel(propsObj.language === 'ko' ? '지난 30일' : 'Last 30 days');
                break;
            case '지난 60일':
            case 'Last 60 days':
                start = moment_1.default().subtract(60, 'day').startOf('day');
                end = moment_1.default().subtract(1, 'day').startOf('day');
                setSelectLabel(propsObj.language === 'ko' ? '지난 60일' : 'Last 60 days');
                break;
            case '지난 90일':
            case 'Last 90 days':
                start = moment_1.default().subtract(90, 'day').startOf('day');
                end = moment_1.default().subtract(1, 'day').startOf('day');
                setSelectLabel(propsObj.language === 'ko' ? '지난 90일' : 'Last 90 days');
                break;
            default:
        }
        if (!['직접 설정', 'Manual settings'].includes(range))
            setDateSelection([]); // 직접 설정이 아닌 다른 기간 프리셋을 선택했을 때 데이트 셀렉션 초기화
        if (props.selectableRange &&
            props.selectableRange.start &&
            moment_1.default.isMoment(props.selectableRange.start) &&
            start &&
            moment_1.default.isMoment(start) &&
            props.selectableRange.start.isAfter(start)) {
            setDateRange({
                start: props.selectableRange.start,
                end: end,
            });
        }
        else
            setDateRange({ start: start, end: end });
    }
    function rowRenderer(_a) {
        var key = _a.key, index = _a.index, style = _a.style;
        return (jsx_runtime_1.jsx("div", tslib_1.__assign({ style: style, className: "" }, { children: items[index] }), key));
    }
    function close() {
        setIsOver(false);
        setShowCalendar(false);
        setDateRange(selectedDateRange || {
            start: moment_1.default().startOf('day'),
            end: moment_1.default().startOf('day'),
        });
        setSelectLabel(propsObj.language === 'ko' ? '직접 설정 기간' : 'Manually set period');
    }
    function submit() {
        setIsOver(false);
        setShowCalendar(false);
        setSelectedDateRange(dateRange);
        setSelectLabel(propsObj.language === 'ko' ? '직접 설정 기간' : 'Manually set period');
        if (props.dateHandle)
            props.dateHandle(dateRange);
    }
    var CalendarControlBtn = function (_a) {
        var index = _a.index, btnName = _a.btnName;
        var isSelectedLabel = selectLabel === btnName ||
            (['직접 설정 기간', 'Manually set period'].includes(selectLabel) &&
                ['직접 설정', 'Manual settings'].includes(btnName));
        return (jsx_runtime_1.jsx("div", tslib_1.__assign({ role: "button", tabIndex: index, className: "bg-calendar-control-btn" + (isSelectedLabel ? ' select' : ''), onClick: function () { return selectRange(btnName); } }, { children: jsx_runtime_1.jsx("span", { children: btnName }, void 0) }), void 0));
    };
    var CalendarControlPanel = function () {
        var koBtnList = [
            '직접 설정',
            '오늘',
            '어제',
            '이번 주',
            '지난 주',
            '지난 7일',
            '지난 14일',
            '지난 30일',
            '지난 60일',
            '지난 90일',
        ];
        var enBtnList = [
            'Manual settings',
            'Today',
            'Yesterday',
            'This week',
            'Last week',
            'Last 7 days',
            'Last 14 days',
            'Last 30 days',
            'Last 60 days',
            'Last 90 days',
        ];
        return (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-control-panel" }, { children: (propsObj.language === 'ko' ? koBtnList : enBtnList).map(function (bname, index) { return (jsx_runtime_1.jsx(CalendarControlBtn, { index: index, btnName: bname }, bname)); }) }), void 0));
    };
    return (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [showCalendar && (jsx_runtime_1.jsx(BDSBackdrop_1.BDSBackdrop, { handleClick: function () { return close(); }, style: { zIndex: 1, backgroundColor: 'rgba(0,0,0,0)' } }, void 0)),
            jsx_runtime_1.jsxs("div", tslib_1.__assign({ style: props.style || {}, css: [BDSCalendar_style_1.baseCss, themeCss], onMouseEnter: function () { return setIsOver(true); }, onMouseLeave: function () { return setIsOver(false); }, className: "bg-calendar-panel " + (showCalendar || isOver ? ' active' : '') + " " + (selectedDateRange ? '' : 'empty') }, { children: [jsx_runtime_1.jsxs("div", tslib_1.__assign({ role: "button", tabIndex: 0, className: "bg-calendar-display", onClick: function () { return setShowCalendar(function (prevState) { return !prevState; }); } }, { children: [props.customDisplayPanel && props.customDisplayPanel(), !props.customDisplayPanel && (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [!selectedDateRange && jsx_runtime_1.jsx(BDSFontIcon_1.BDSFontIcon, { name: "ic-add", color: "#7e8696", size: "20px" }, void 0),
                                    selectedDateRange ? (jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "bg-calendar-display-inner" }, { children: [jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-display-label" }, { children: propsObj.preLabel || '' }), void 0),
                                            jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "bg-calendar-current-date" }, { children: [props.isSingleDateRange && (selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange.start.format('YYYY.MM.DD')),
                                                    !props.isSingleDateRange &&
                                                        (selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange.start.format('YYYY.MM.DD')) + " ~ " + (selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange.end.format('YYYY.MM.DD'))] }), void 0)] }), void 0)) : (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-display-label", style: { margin: '0 0 0 4px' } }, { children: propsObj.language === 'ko' ? '비교 기간 추가' : 'Add comparison period' }), void 0)),
                                    selectedDateRange &&
                                        !propsObj.isComparablePeriod &&
                                        (showCalendar ? (jsx_runtime_1.jsx(BDSFontIcon_1.BDSFontIcon, { name: "ic-arrow-left", color: "#7e8696", size: "20px" }, void 0)) : (jsx_runtime_1.jsx(BDSFontIcon_1.BDSFontIcon, { name: "ic-arrow-right", color: "#7e8696", size: "20px" }, void 0))),
                                    selectedDateRange && propsObj.isComparablePeriod && (jsx_runtime_1.jsx(BDSFontIcon_1.BDSFontIcon, { name: "ic-close", color: "#7e8696", size: "20px", handleClick: function (e) {
                                            e.stopPropagation();
                                            if (props.unsetHandle)
                                                props.unsetHandle();
                                        } }, void 0))] }, void 0))] }), void 0),
                    showCalendar && (jsx_runtime_1.jsx("div", tslib_1.__assign({ style: props.calendarStyle || {}, className: " " + (props.position === 'top' ? 'position-top' : 'position-bottom') }, { children: jsx_runtime_1.jsx(BDSBorderSection_1.BDSBorderSection, tslib_1.__assign({ style: { overflow: 'hidden', borderColor: Theme_1.lightTheme.colors.divider, borderRadius: '12px' } }, { children: jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "bg-calendar-selector-panel", style: { width: props.hiddenControlPanel ? '290px' : '450px' } }, { children: [!props.hiddenControlPanel && jsx_runtime_1.jsx(CalendarControlPanel, {}, void 0),
                                    jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "bg-calendar-display-panel" }, { children: [!props.hiddenHeader && (jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "bg-calendar-display-header" }, { children: [jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-display-header-label" }, { children: selectLabel }), void 0),
                                                    jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "bg-calendar-display-header-value" }, { children: [props.isSingleDateRange && (dateRange === null || dateRange === void 0 ? void 0 : dateRange.start.format('YYYY.MM.DD')),
                                                            !props.isSingleDateRange &&
                                                                (dateRange === null || dateRange === void 0 ? void 0 : dateRange.start.format('YYYY.MM.DD')) + " - " + (dateRange === null || dateRange === void 0 ? void 0 : dateRange.end.format('YYYY.MM.DD'))] }), void 0)] }), void 0)),
                                            jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "bg-calendar-display-content" }, { children: [jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "bg-calendar-display-content-day-panel" }, { children: [jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-display-content-day" }, { children: jsx_runtime_1.jsx("span", { children: propsObj.language === 'ko' ? '일' : 'SUN' }, void 0) }), void 0),
                                                            jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-display-content-day" }, { children: jsx_runtime_1.jsx("span", { children: propsObj.language === 'ko' ? '월' : 'MON' }, void 0) }), void 0),
                                                            jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-display-content-day" }, { children: jsx_runtime_1.jsx("span", { children: propsObj.language === 'ko' ? '화' : 'TUE' }, void 0) }), void 0),
                                                            jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-display-content-day" }, { children: jsx_runtime_1.jsx("span", { children: propsObj.language === 'ko' ? '수' : 'WED' }, void 0) }), void 0),
                                                            jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-display-content-day" }, { children: jsx_runtime_1.jsx("span", { children: propsObj.language === 'ko' ? '목' : 'THU' }, void 0) }), void 0),
                                                            jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-display-content-day" }, { children: jsx_runtime_1.jsx("span", { children: propsObj.language === 'ko' ? '금' : 'FRI' }, void 0) }), void 0),
                                                            jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-display-content-day" }, { children: jsx_runtime_1.jsx("span", { children: propsObj.language === 'ko' ? '토' : 'SAT' }, void 0) }), void 0)] }), void 0),
                                                    jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "bg-calendar-month-panel" }, { children: jsx_runtime_1.jsx(react_virtualized_1.List, { ref: listRef, width: props.hiddenControlPanel ? props.monthWidth || 305 : 305, height: 320, rowCount: items.length, rowHeight: 240, rowRenderer: rowRenderer, style: { marginRight: '-50px' } }, void 0) }), void 0),
                                                    jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "bg-calendar-select-panel" }, { children: [jsx_runtime_1.jsx("div", tslib_1.__assign({ role: "button", tabIndex: 0, className: "bg-calendar-select-cancel", onClick: function () { return close(); } }, { children: jsx_runtime_1.jsx("span", { children: propsObj.language === 'ko' ? '취소' : 'cancel' }, void 0) }), void 0),
                                                            jsx_runtime_1.jsx("div", tslib_1.__assign({ role: "button", tabIndex: 0, className: "bg-calendar-select-apply", onClick: function () { return submit(); } }, { children: jsx_runtime_1.jsx("span", { children: propsObj.language === 'ko' ? '적용' : 'apply' }, void 0) }), void 0)] }), void 0)] }), void 0)] }), void 0)] }), void 0) }), void 0) }), void 0))] }), void 0)] }, void 0));
};
exports.BDSCalendar = BDSCalendar;
var templateObject_1;
